import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import CookieConsent from './components/CookieConsent';
import Hero from './sections/Hero';
import MissionVision from './sections/MissionVision';
import Pricing from './sections/Pricing';
import FreeMealPlan from './sections/FreeMealPlan';
import CommunityPreview from './sections/CommunityPreview';
import ClientSuccessStories from './sections/ClientSuccessStories';
import Footer from './components/Footer';
// Page components are now wired in index.js router

// Home Page Component
export const HomePage = () => (
  <div style={{ backgroundColor: '#F5EBDD' }}>
    <Hero />
    <MissionVision />
    <CommunityPreview />
    <Pricing />
  </div>
);

function Layout() {
  const location = useLocation();
  // Scroll to top on route change (global behavior)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="App">
      <Navbar />
      {/* Keyed wrapper forces remount of child route on path change */}
      <div key={location.pathname}>
        <Outlet />
      </div>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default Layout;
